import CryptoJS from 'crypto';

export const getSessionItem = (item)=>{
  let str = sessionStorage.getItem(item)
  let result = null
  if(str) {
    result = JSON.parse(str)
  } 
  return result
}

/**
 * 对象深拷贝
 * @param  obj 对象
 */
export function cloneObj(obj) {
  let str
  let newObj = obj.constructor === Array ? [] : {};
  if (
    Object.prototype.toString.call(obj) !== '[object Object]' &&
    Object.prototype.toString.call(obj) !== '[object Array]'
  ) {
    return
  } else if (window.JSON) {
    str = JSON.stringify(obj) // 系列化对象
    newObj = JSON.parse(str) // 还原
  } else {
    for (let i in obj) {
      newObj[i] = typeof obj[i] === 'object' ? this.cloneObj(obj[i]) : obj[i]
    }
  }
  return newObj
}

//confirm util
export const confirm = (context,tip,cb,title = '提示',okText = '确定',cancelText = '取消')=>{
  context.$confirm(tip, title, {
    confirmButtonText: okText,
    cancelButtonText: cancelText,
    type: 'warning'
  }).then(() => {
    cb()
  }).catch(() => {
  
  })
}

//表单序列化
export const serialize = data => {
  let list = [];
  Object.keys(data).forEach(ele => {
      list.push(`${ele}=${data[ele]}`)
  })
  return list.join('&');
};

// 邮箱脱敏 [显示前4位 1234****@qq.com]
export const  desensitize = (str) => {
  str.replace(/(?<=.{4})[^@]+(?=.{0}@)/,"****")
}

//DES 加密 [str: 需要加密的str； key：秘钥]
export const encryptByDES = (str, key) => {
  var keyHex = new Buffer(key);
  var iv = new Buffer([1, 2, 3, 4, 5, 6, 7, 8]);
  var cipher = CryptoJS.createCipheriv("des-cbc", keyHex, iv);
  cipher.setAutoPadding(true); // default true
  var ciph = cipher.update(str, "utf8", "base64");
  ciph += cipher.final("base64");
  return ciph;
}
// 计算文本实际宽度
export function getTextWidth(text) {
  const span = document.createElement('span')
  span.innerHTML = text
  span.style.visibility = 'hidden'
  document.body.appendChild(span)
  const width = span.offsetWidth
  document.body.removeChild(span)
  return width
}
export const getQueryString = (name) => {
  var reg = new RegExp("(^|\\?|&)" + name + "=([^&]*)(\\s|&|$)", "i");
  if (reg.test(window.location.href)) return unescape(RegExp.$2.replace(/\+/g, " ")); return "";
}

/*
* 清空session和local storage
* @p session-清空seeionStorage
* @p local-清空localStorage
*/
export const clearSessLocal = (session, local) => {
  if (session) {
    sessionStorage.clear();
  }
  if (local) {
    localStorage.clear();
  }
}